/** القسم 3 — «إطار الشراكة مع الوكالات وخطة التفعيل والإطلاق خلال 90 يومًا» (ملف PDF العربي). */
export const partnershipAr = {
  id: 'partnership',
  previewCount: 3,
  navLabel: 'إطار الشراكة',
  eyebrow: 'الشراكة مع الوكالات',
  title: 'إطار الشراكة مع الوكالات وخطة التفعيل والإطلاق خلال 90 يومًا',
  subtitle:
    'تكامل واضح للأدوار: حلول تقود الرؤية والأجندة الاقتصادية والاستثمارية، والوكالة تقود الوصول والتنفيذ الإعلامي والتجاري داخل السوق المحلي.',
  blocks: [
    {
      icon: 'campaign',
      title: 'مقدمة',
      wide: true,
      paragraphs: [
        'المبادرة الإعلامية الاقتصادية العالمية لحلول هي مشروع إعلامي اقتصادي واستثماري دولي يهدف إلى بناء شبكة إعلامية مترابطة بين الدول والأسواق، تستخدم الإعلام كأداة لعرض رؤى الدول وتسويق اقتصاداتها وفتح أسواقها، وربطها بالمستثمرين والشركات والمؤسسات والفرص الدولية.',
        'وتنطلق المبادرة من رؤية مختلفة لدور الإعلام الاقتصادي؛ فالإعلام هنا لا يقتصر على نقل الأخبار أو عرض المشروعات، وإنما يصبح وسيلة لفهم توجهات الدول واحتياجاتها، والتعريف بفرصها، وبناء الحوار مع الأطراف القادرة على المشاركة فيها، وفتح مسارات جديدة للعلاقات الاقتصادية والاستثمارية.',
        'ولا تقتصر المبادرة على برنامج تلفزيوني واحد، وإنما يمثل البرنامج أحد المنتجات الإعلامية للمشروع، إلى جانب المحتوى الرقمي والحوارات واللقاءات والفعاليات وغيرها من الأدوات الإعلامية التي تخدم أهدافه.',
        'ومن هنا تأتي أهمية الشراكة مع الوكالات الإعلامية في الأسواق المختلفة، باعتبارها شريكًا محليًا يمتلك المعرفة بالسوق والعلاقات الإعلامية والمؤسسية والقدرة على التنفيذ، بينما تتولى حلول قيادة الرؤية والأجندة الاقتصادية والاستثمارية للمشروع.',
      ],
    },
    {
      icon: 'join_inner',
      title: 'طبيعة الشراكة والهدف منها',
      paragraphs: [
        'تقوم الشراكة على التكامل بين قدرات وخبرات الطرفين، بهدف إطلاق المبادرة وتفعيلها داخل السوق المحلي بصورة تحقق قيمة إعلامية واقتصادية واستثمارية حقيقية.',
      ],
      listLabel: 'وتقوم العلاقة على أن:',
      bullets: [
        'تتولى حلول قيادة الرؤية العامة للمشروع والأجندة الاقتصادية والاستثمارية.',
        'تتولى الوكالة دور الشريك الإعلامي والتنفيذي والتجاري داخل السوق.',
        'يعمل الطرفان بصورة مشتركة للوصول إلى الجهات والشخصيات والفرص التي تخدم أهداف المشروع.',
        'يتم تطوير المحتوى والبرامج واللقاءات وفقًا للأهداف الاقتصادية والاستثمارية المحددة للسوق.',
      ],
      closing:
        'والهدف ليس إنتاج محتوى إعلامي فقط، وإنما بناء مشروع إعلامي قادر على فتح الحوار والعلاقات والوصول إلى الفرص الاقتصادية والاستثمارية.',
    },
    {
      icon: 'workspace_premium',
      title: 'دور حلول في المشروع',
      paragraphs: [
        'تتولى حلول المسؤولية الاستراتيجية عن المبادرة، باعتبارها صاحبة المشروع والعلامة والنموذج. ويشمل دورها:',
      ],
      bullets: [
        'وضع الرؤية العامة والأهداف الاستراتيجية للمشروع.',
        'إدارة الأجندة الاقتصادية والاستثمارية للمحتوى.',
        'فهم رؤية الدولة وأولوياتها واحتياجاتها وفرصها بالتنسيق مع الجهات المعنية.',
        'تحديد القطاعات والملفات الاقتصادية والاستثمارية ذات الأولوية.',
        'تحديد نوعية الشخصيات والجهات التي ينبغي استهدافها لتحقيق أهداف المشروع.',
        'إدارة العلاقات الاستراتيجية المرتبطة بالمشروع.',
        'ربط السوق المحلي بالأسواق والمستثمرين والشركات والمؤسسات من الأسواق الأخرى.',
        'تطوير العلاقات والفرص التي تنشأ من خلال المحتوى واللقاءات.',
        'الحفاظ على هوية المشروع وأهدافه ومعاييره في مختلف الأسواق.',
      ],
      closing:
        'وبالتالي، فإن دور حلول لا يقتصر على إنتاج المحتوى، وإنما يتمثل في إدارة البعد الاقتصادي والاستثماري للمشروع، وتحديد ما الذي نريد تحقيقه، ومع من، ولماذا، وكيف يمكن تحويل العلاقات التي يصنعها الإعلام إلى فرص حقيقية.',
    },
    {
      icon: 'groups',
      title: 'دور الوكالة الشريكة',
      paragraphs: [
        'تمثل الوكالة الشريك المحلي الذي يساهم بخبرته وعلاقاته وقدراته الإعلامية والتجارية في تفعيل المشروع داخل السوق. ويشمل دورها:',
      ],
      bullets: [
        'تسهيل الوصول إلى الجهات الحكومية والاقتصادية والاستثمارية والإعلامية ذات الصلة.',
        'المساعدة في ترتيب اللقاءات مع الشخصيات والجهات المستهدفة.',
        'تقديم المعرفة بالسوق المحلي وطبيعة جمهوره ووسائله الإعلامية.',
        'تنفيذ عمليات الإنتاج والتصوير والإخراج والتجهيزات الفنية.',
        'التنسيق مع القنوات والمنصات ووسائل الإعلام المحلية.',
        'تطوير الرعاية والإعلانات والشراكات التجارية في السوق.',
        'تنفيذ الحملات الإعلامية والترويجية.',
        'إدارة عمليات النشر والتوزيع الإعلامي المحلي.',
        'المساهمة في تنظيم اللقاءات والفعاليات المرتبطة بالمشروع.',
        'إدارة التنفيذ المحلي بالتنسيق المستمر مع فريق حلول.',
      ],
      closing:
        'وتكون الوكالة شريكًا أساسيًا في نجاح المشروع داخل السوق، مع الحفاظ على التكامل الواضح بين مسؤوليتها التنفيذية المحلية والدور الاستراتيجي لحلول.',
    },
    {
      icon: 'person_search',
      title: 'إدارة المحتوى واختيار الضيوف',
      wide: true,
      paragraphs: [
        'تتم إدارة المحتوى وفقًا للأهداف الاقتصادية والاستثمارية التي يسعى المشروع إلى تحقيقها في كل سوق.',
        'وتتولى حلول قيادة الأجندة الاستراتيجية وتحديد الملفات والأهداف والجهات والشخصيات ذات الأولوية، بينما تقدم الوكالة رؤيتها المحلية بشأن أفضل طرق الوصول والتنفيذ الإعلامي.',
        'ويتم اختيار الضيوف والجهات ليس لمجرد الظهور الإعلامي، وإنما وفق القيمة التي يمكن أن يضيفها حضورهم إلى أهداف المشروع، سواء من خلال المعرفة أو العلاقات أو الاستثمار أو الشراكات أو فتح أسواق جديدة.',
      ],
      closing:
        'وبذلك يكون المحتوى الإعلامي جزءًا من مشروع اقتصادي واستثماري أكبر، وليس هدفًا قائمًا بذاته.',
    },
    {
      type: 'phases',
      icon: 'event_upcoming',
      title: 'خطة التفعيل والإطلاق خلال 90 يومًا',
      outcomeLabel: 'النتيجة المستهدفة',
      items: [
        {
          tag: 'المرحلة الأولى — أول 30 يومًا',
          title: 'التأسيس وتحديد الأجندة',
          bullets: [
            'تشكيل فريق العمل المشترك.',
            'تحديد المسؤوليات ونقاط الاتصال.',
            'بدء التواصل مع الجهات الحكومية والاقتصادية والاستثمارية المستهدفة.',
            'التعرف على أولويات السوق واحتياجاته وفرصه.',
            'تحديد القطاعات والموضوعات الرئيسية.',
            'إعداد قائمة أولية بالضيوف والجهات المستهدفة.',
            'وضع التصور الإعلامي والتنفيذي.',
            'إعداد التصور التجاري الأولي للرعاية والشراكات.',
          ],
          outcome: 'اعتماد الأجندة الأساسية وخطة العمل وقائمة الجهات والشخصيات ذات الأولوية.',
        },
        {
          tag: 'المرحلة الثانية — من اليوم 31 إلى اليوم 60',
          title: 'التحضير والتفعيل',
          bullets: [
            'تثبيت الموضوعات والملفات الرئيسية.',
            'بدء تأكيد مشاركة الشخصيات والجهات المستهدفة.',
            'تطوير عروض الرعاية والشراكات التجارية.',
            'استكمال الترتيبات الإعلامية والفنية.',
            'تحديد جدول الإنتاج والتصوير.',
            'إعداد المواد الترويجية.',
            'التنسيق مع الأطراف الدولية ذات الصلة بالموضوعات والفرص المطروحة.',
          ],
          outcome: 'جاهزية المحتوى والضيوف والشركاء التجاريين وخطة الإنتاج والإطلاق.',
        },
        {
          tag: 'المرحلة الثالثة — من اليوم 61 إلى اليوم 90',
          title: 'الإنتاج والإطلاق',
          bullets: [
            'تنفيذ الإنتاج والتصوير.',
            'إطلاق الحملة الإعلامية والترويجية.',
            'إطلاق البرنامج والمحتوى عبر الوسائل والمنصات المتفق عليها.',
            'تفعيل الحضور الرقمي والإعلامي.',
            'تنظيم اللقاءات والحوارات المرتبطة بالمشروع عند الحاجة.',
            'متابعة العلاقات والفرص التي تنشأ من المشروع.',
            'تقييم نتائج المرحلة الأولى ووضع خطة المرحلة التالية.',
          ],
          outcome:
            'إطلاق فعلي للمشروع داخل السوق، وتحقيق حضور إعلامي واقتصادي، وبدء بناء العلاقات والفرص الناتجة عن المشروع.',
        },
      ],
    },
    {
      icon: 'payments',
      title: 'النموذج التجاري',
      paragraphs: [
        'يقوم التعاون على مبدأ أن القيمة التي يصنعها كل طرف يجب أن تنعكس في النموذج التجاري للشراكة.',
        'ويتم الاتفاق على النموذج المالي المناسب وفقًا لطبيعة السوق وحجم مساهمة كل طرف ومسؤولياته الفعلية.',
      ],
      listLabel: 'ويمكن أن تشمل مجالات العائد:',
      bullets: [
        'الرعاية.',
        'الإعلانات والشراكات التجارية.',
        'الخدمات والمنتجات الإعلامية.',
        'الفعاليات واللقاءات الاقتصادية.',
        'الفرص والمشروعات التي تنشأ من العلاقات التي يساهم المشروع في بنائها وتطويرها.',
      ],
      closing:
        'وتحدد التفاصيل المالية وآليات توزيع العوائد ضمن الاتفاق التجاري والقانوني النهائي بين الطرفين.',
    },
    {
      icon: 'history_edu',
      title: 'الخطوات التالية والإطار القانوني',
      paragraphs: ['بعد الموافقة المبدئية على إطار التعاون، يتم الانتقال إلى:'],
      numbered: [
        'تشكيل فريق العمل المشترك.',
        'عقد اجتماع عمل لتحديد أولويات السوق.',
        'تحديد الجهات والشخصيات والملفات ذات الأولوية.',
        'اعتماد الأجندة الإعلامية والاقتصادية والاستثمارية.',
        'اعتماد خطة الإنتاج والإطلاق.',
        'الاتفاق على النموذج التجاري.',
        'إعداد وتوقيع الاتفاقية القانونية المنظمة للشراكة.',
      ],
      listLabel: 'وتتضمن الاتفاقية النهائية، بحسب ما يتم الاتفاق عليه، تحديد:',
      bullets: [
        'مسؤوليات كل طرف.',
        'حقوق الملكية الفكرية والعلامة.',
        'السرية وحماية المعلومات.',
        'النموذج التجاري والعوائد.',
        'مدة الشراكة.',
        'آلية الإدارة واتخاذ القرار.',
        'آلية التوسع والتجديد أو إنهاء التعاون.',
      ],
      closing:
        'وتظل مدة التسعين يومًا إطارًا عمليًا مقترحًا للتفعيل والإطلاق، ويمكن تعديل تفاصيلها وفقًا لطبيعة السوق وسرعة الإجراءات والاتفاق بين الطرفين.',
    },
    {
      icon: 'flag',
      title: 'الخلاصة',
      wide: true,
      highlight: true,
      paragraphs: [
        'المبادرة لا تهدف إلى إنتاج برنامج إعلامي تقليدي، وإنما إلى بناء مشروع إعلامي اقتصادي واستثماري يستخدم قوة الإعلام في عرض رؤى الدول، وتسويق اقتصاداتها، وفتح أسواقها، وربطها بالمستثمرين والشركات والمؤسسات والفرص الدولية.',
        'وتقوم الشراكة على تكامل واضح: حلول تقود الرؤية والأجندة الاقتصادية والاستثمارية والعلاقات الاستراتيجية، والوكالة تقود الوصول والتنفيذ الإعلامي والتجاري داخل السوق المحلي.',
        'ومن خلال هذا التكامل، يصبح الإعلام نقطة انطلاق لبناء العلاقات، وفتح الأسواق، وتطوير الفرص الاقتصادية والاستثمارية.',
      ],
    },
  ],
};
